/** Shared locale tables (GPL-3.0 game strings). */
export const lang = {};
